export default "__VITE_ASSET__ce409823__"